import { useRouteResponse } from "@src/app/hooks/useRouteResponse";
import { Section } from "@src/app/types/Data";
import { BFF_ENDPOINT } from "@src/app/utils/bff";

/**
 * @deprecated
 */
export default function ArticleSEO() {
  const res = useRouteResponse("articlePage");
  const article = res.article;
  const defaultImage = `${BFF_ENDPOINT}/icons/redants-logo.jpg`;

  // Get main media image
  const mainMediaImageUrl =
    res.article?.section === Section.VIDEOS
      ? article?.mainMedia.find((i) => i.type === "youtube_video")?.poster ||
        defaultImage
      : article?.mainMedia.find((i) => i.type === "image")?.url || defaultImage;

  // Get Author Name and URL
  const authorsName = article?.authors[0]?.name || "红蚂蚁";
  const authorsURL = article?.authors[0]?.urlPath || "";

  // Get main entity URL
  const mainEntity = `${BFF_ENDPOINT}${article?.urlPath || ""}`;

  // Generate SEO JSON-LD string
  const SEOString = `
    {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "NewsArticle",
          "headline": "${article?.title || ""}",
          "name": "${article?.title || ""}",
          "image": {
            "@type": "ImageObject",
            "representativeOfPage": "True",
            "url": "${mainMediaImageUrl}"
          },
          "datePublished": "${article?.created || ""}",
          "dateModified": "${article?.updated || ""}",
          "author": {
            "@type": "Person",
            "name": "${authorsName}",
            "url": "${authorsURL}"
          },
          "publisher": {
            "@type": "Organization",
            "@id": "https://www.redants.sg/",
            "name": "红蚂蚁",
            "url": "https://www.redants.sg/",
            "logo": {
              "@type": "ImageObject",
              "url": "${BFF_ENDPOINT}/icons/503-logo.png",
              "width": "121",
              "height": "83"
            }
          },
          "mainEntityOfPage": "${article?.urlPath ? mainEntity : ""}"
        },
        {
          "thumbnailUrl": "${mainMediaImageUrl}"
        }
      ]
    }
  `;

  return (
    <script id="seo-article-page" type="application/ld+json">
      {SEOString}
    </script>
  );
}

export function useArticleSEO() {
  const res = useRouteResponse("articlePage");
  const article = res.article;
  const defaultImage = `${BFF_ENDPOINT}/icons/redants-logo.jpg`;

  // Get main media image
  const mainMediaImageUrl =
    res.article?.section === Section.VIDEOS
      ? article?.mainMedia.find((i) => i.type === "youtube_video")?.poster ||
        defaultImage
      : article?.mainMedia.find((i) => i.type === "image")?.url || defaultImage;

  // Get Author Name and URL
  const authorsName = article?.authors[0]?.name || "红蚂蚁";
  const authorsURL = article?.authors[0]?.urlPath || "";

  // Get main entity URL
  const mainEntity = `${BFF_ENDPOINT}${article?.urlPath || ""}`;

  // Generate SEO JSON-LD string
  const articleSEOStr = `
    {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "NewsArticle",
          "headline": "${article?.title || ""}",
          "name": "${article?.title || ""}",
          "image": {
            "@type": "ImageObject",
            "representativeOfPage": "True",
            "url": "${mainMediaImageUrl}"
          },
          "datePublished": "${article?.created || ""}",
          "dateModified": "${article?.updated || ""}",
          "author": {
            "@type": "Person",
            "name": "${authorsName}",
            "url": "${authorsURL}"
          },
          "publisher": {
            "@type": "Organization",
            "@id": "https://www.redants.sg/",
            "name": "红蚂蚁",
            "url": "https://www.redants.sg/",
            "logo": {
              "@type": "ImageObject",
              "url": "${BFF_ENDPOINT}/icons/503-logo.png",
              "width": "121",
              "height": "83"
            }
          },
          "mainEntityOfPage": "${article?.urlPath ? mainEntity : ""}"
        },
        {
          "thumbnailUrl": "${mainMediaImageUrl}"
        }
      ]
    }
  `;
  return {
    articleSEOStr,
  };
}
